import { TraceableProcess, TrackingEvent } from '../../../services/analytics/model';

export class CallSupportRequested implements TrackingEvent {
  public readonly category = TraceableProcess.AUTOPUBLISH;
  public readonly action = 'CallSupportRequested';
  public readonly label = 'autopublish_call_started';
}
